import Vue from 'vue'
import App from './App'
import router from './router'
import store from './store'
import ElementUI from 'element-ui'
import axios from 'axios'
import qs from 'qs'

// 引入css重置样式
import './assets/css/reset.css'
// 引入element-ui样式
import 'element-ui/lib/theme-chalk/index.css'
// 引入css公共样式
import './assets/css/index.css'
// 引入js配置选项脚本
import myOption from './assets/js/myOption'

import echarts from 'echarts'
import http from './assets/js/http'
import utils from './assets/js/utils'

Vue.prototype.$echarts = echarts
Vue.prototype.$http = http
Vue.prototype.$utils = utils

// 调用element-ui
Vue.use(ElementUI)

// 生产消息
Vue.config.productionTip = false
// 注册请求脚本
Vue.prototype.$axios = axios
// 注册请求依赖脚本
Vue.prototype.qs = qs
// 注册js公共脚本
Vue.prototype.myOption = myOption

// Vue实例配置参数
const VueParam = {
  router,
  store,
  components: { App },
  template: '<App/>'
}

// 免登录白名单
const whiteList = [
  '/login',
  '/jump'
]

// 路由跳转前，登录状态判断
router.beforeEach((to, from, next) => {
  // 页面刷新状态
  let isRefresh = false

  // 在页面加载时读取sessionStorage里的状态信息
  let user = myOption.storage.user
  if (sessionStorage.getItem(user)) {
    store.replaceState(Object.assign({}, store.state, {user: JSON.parse(sessionStorage.getItem(user))}))
    sessionStorage.removeItem(user)
    isRefresh = true
  }

  // 登录状态
  if (store.getters.isToken) {
    // 登录状态跳转登录页
    if (whiteList.indexOf(to.path) !== -1) {
      // 注销登录
      store.dispatch('FedLogOut').then(() => {
        // 重定向
        next({ path: '/logo' })
        window.location.reload()
      })
    // 其他页面跳转
    } else {
      // 判断刷新状态或者角色路由状态
      if (isRefresh || store.getters.isAddRouters) {
        // 获取权限
        store.dispatch('GetPowerList').then((power) => {
          // 生成可访问的路由表
          store.dispatch('GenerateRoutes', [power, store.state.user.info.isSspUser]).then(() => {
            // 动态添加可访问路由表
            router.addRoutes(store.state.router.routers)
            // hack方法 确保addRoutes已完成
            // next({ ...to, replace: true })
            next({ ...to })
          })
        // 如果权限不存在
        }).catch(() => {
          // 注销登录
          store.dispatch('FedLogOut').then(() => {
            // 注销提示信息
            ElementUI.Message.error('验证失败，请重新登录')
            // 重定向
            next({ path: '/logo' })
          })
        })
      // 非以上两种状态任意一种
      } else {
        // 如果是主页面，跳转至角色路由下第一菜单
        if (to.path === '/home' || to.path === '/home/') {
          const firstChildPath = store.state.router.addRouters[0].children[0].path
          console.log('firstChildPath', firstChildPath)
          next({path: '/home/' + firstChildPath})
        } else {
          next()
        }
      }
    }
  // 未登录状态
  } else {
    // 在免登录白名单，直接进入
    if (whiteList.indexOf(to.path) !== -1) {
      next()
    // 否则全部重定向到登录页
    } else {
      next({ path: '/' })
    }
  }
})

// 创建Vue实例，并进行挂载
new Vue(VueParam).$mount('#app')



// WEBPACK FOOTER //
// ./src/main.js